<div class="d-flex row-cols-12">
    <div class="col-12">
        <h3 class="title float-start" translate>Settings.Services</h3>
    </div>
</div>

<div class="p-4 pt-0">
    <div class="mb-3 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
        <ul class="mt-2 w-100 list-group sourceheader rounded-bottom-0">
            <li class="list-group-item subheader d-block py-1">
                <div class="row w-100 d-flex align-items-center">
                    <div class="col-12"><span translate="Settings.IntegrationsImportExportSection.Source"></span></div>
                </div>
            </li>
        </ul>
        <ul class="w-100 list-group rounded-top-0">

            <app-hide-by-permission-wrapper [forPermission]="permissionEnum.Perm_XbrlRenderService">
                <li class="list-group-item d-block py-1">
                    <div class="row w-100 d-flex align-items-center">
                        <div class="col-6 text-truncate float-none form-check form-switch">
                            <input class="switch-form-default float-none form-check-input items" type="checkbox"
                                role="switch" id="UseXBRLrenderservice" checked 
                                [disabledByPermission]="permissionEnum.Perm_XbrlRenderService">
                            <label class="col-10" for="UseXBRLrenderservice"
                                translate="Settings.IntegrationsServicesSection.XbrlRenderService"></label>
                        </div>
                        <div class="col-4"></div>
                        <div class="col-2 text-end">
                            <div class="btn-group">
                                <button type="button" class="btn bg-transparent border-0 p-0" data-bs-toggle="dropdown"
                                    aria-expanded="false">
                                    <i class="bi bi-three-dots bi-large"></i>
                                </button>
                                <ul class="dropdown-menu">
                                    <li><a class="dropdown-item pt-1 pb-1" (click)="openXBRLrenderserviceModal()"
                                            translate="Button.Edit"></a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </li>
            </app-hide-by-permission-wrapper>

            <app-hide-by-permission-wrapper [forPermission]="permissionEnum.Perm_Digipoort">
                <li class="list-group-item d-block py-1">
                    <div class="row w-100 d-flex align-items-center">
                        <div class="col-6 text-truncate float-none form-check form-switch">
                            <input class="switch-form-default float-none form-check-input items" type="checkbox"
                                role="switch" id="UseDigipoort" checked 
                                [disabledByPermission]="permissionEnum.Perm_Digipoort">
                            <label class="col-10" for="UseDigipoort"
                                translate="Settings.IntegrationsServicesSection.Digipoort"></label>
                        </div>
                        <div
                            [ngClass]="{'col-4': digipoort !== 'aansluitsuite', 'col-2': digipoort === 'aansluitsuite'}">
                            <span class="mt-0 ms-2 border-radius-profile badge bg-warning information bold"
                                *ngIf="digipoort === 'aansluitsuite'"
                                translate="Settings.IntegrationsServicesSection.ConnectionSuite"></span>
                            <span class="mt-0 ms-2 border-radius-profile badge bg-warning information bold"
                                *ngIf="digipoort === 'preproductie'"
                                translate="Settings.IntegrationsServicesSection.Testpreproduction"></span>
                            <span class="mt-0 ms-2 border-radius-profile badge bg-success information bold"
                                *ngIf="digipoort === 'productie'"
                                translate="Settings.IntegrationsServicesSection.Production"></span>
                        </div>
                        <div class="col-2" *ngIf="digipoort === 'aansluitsuite'">
                            <span
                                class="mt-0 ms-2 border-radius-profile badge bg-warning information bold">{{flow}}</span>
                        </div>
                        <div class="col-2 text-end">
                            <div class="btn-group">
                                <button type="button" class="btn bg-transparent border-0 p-0" data-bs-toggle="dropdown"
                                    aria-expanded="false">
                                    <i class="bi bi-three-dots bi-large"></i>
                                </button>
                                <ul class="dropdown-menu">
                                    <li><a class="dropdown-item pt-1 pb-1" (click)="openDigipoortModal()"
                                            translate="Button.Edit"></a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </li>
            </app-hide-by-permission-wrapper>

            <app-hide-by-permission-wrapper [forPermission]="permissionEnum.Perm_SBRNexus">
                <li class="list-group-item d-block py-1">
                    <div class="row w-100 d-flex align-items-center">
                        <div class="col-6 text-truncate float-none form-check form-switch">
                            <input class="switch-form-default float-none form-check-input items" type="checkbox"
                                role="switch" id="UseSBRNexus" checked 
                                [disabledByPermission]="permissionEnum.Perm_SBRNexus">
                            <label class="col-10" for="UseSBRNexus"
                                translate="Settings.IntegrationsServicesSection.SBRNexus"></label>
                        </div>
                        <div class="col-4">
                            <span *ngIf="sbrNexus === 'BTBA'"
                                class="mt-0 ms-2 border-radius-profile badge bg-warning information bold"
                                translate="Settings.IntegrationsServicesSection.Acceptation"></span>
                            <span *ngIf="sbrNexus === 'BTP'"
                                class="mt-0 ms-2 border-radius-profile badge bg-success information bold"
                                translate="Settings.IntegrationsServicesSection.Production"></span>
                        </div>
                        <div class="col-2 text-end">
                            <div class="btn-group">
                                <button type="button" class="btn bg-transparent border-0 p-0" data-bs-toggle="dropdown"
                                    aria-expanded="false">
                                    <i class="bi bi-three-dots bi-large"></i>
                                </button>
                                <ul class="dropdown-menu">
                                    <li><a class="dropdown-item pt-1 pb-1" (click)="openSbrNexusModal()"
                                            translate="Button.Edit"></a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </li>
            </app-hide-by-permission-wrapper>
        </ul>
    </div>
</div>